export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },

    showTable({commit}) {
        commit('showTable');
    },
    showForm({commit}) {
        commit('showForm');
    },
    showCovidRATForm({commit}) {
        commit('showCovidRATForm');
    },

    showEHRLabTable({commit}) {
        commit('showEHRLabTable');
    },
    showEHRLabForm({commit}) {
        commit('showEHRLabForm');
    }
}
